module.exports = __webpack_public_path__ + "static/media/snapshift-4.298d6d6f.png";